<template>
  <base-event-log-item
    :icon="icon"
    :icon-color="iconColor"
    :researcher="referenceEventLog.eventBy"
    :date="referenceEventLog.createdAt"
    :bottom-node="bottomNode"
  >
    <div class="text-overflow-ellipsis">
      <span class="font-weight-medium">Comment</span>
      <span class="font-weight-light">
        {{ verbs }}
      </span>
    </div>
    <template #append>
      <div class="comment-area pa-3 caption mt-3" :class="{ strike }">
        <span>{{ referenceEventLog.payload.commentText }}</span>
      </div>
    </template>
  </base-event-log-item>
</template>
<script>
import BaseEventLogItem from './BaseEventLogItem';
import { ReferenceEventLog, Reference } from '@/models';
import { ReferenceEvent } from '@/enums';

const EVENT_TO_STYLE_PROPS = {
  [ReferenceEvent.COMMENT_CREATE]: {
    verbs: 'added',
    icon: { name: 'add_comment', color: 'success' },
    strike: false,
  },
  [ReferenceEvent.COMMENT_EDIT]: {
    verbs: 'edited',
    icon: { name: 'mode_comment', color: 'warning' },
    strike: false,
  },
  [ReferenceEvent.COMMENT_DELETE]: {
    verbs: 'deleted',
    icon: { name: 'mode_comment', color: 'error' },
    strike: true,
  },
};

export default {
  name: 'CommentEventLogItem',
  components: { BaseEventLogItem },
  props: {
    referenceEventLog: {
      type: ReferenceEventLog,
      required: true,
    },
    reference: {
      type: Reference,
      required: true,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    verbs() {
      return this.styleProps.verbs;
    },
    icon() {
      return this.styleProps.icon.name;
    },
    iconColor() {
      return this.styleProps.icon.color;
    },
    strike() {
      return this.styleProps.strike;
    },
    styleProps() {
      return EVENT_TO_STYLE_PROPS[this.referenceEventLog.event];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.text-overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
.comment-area {
  background-color: white;
  border: 1px solid map-get($grey, 'lighten-2');
}
.comment-area > span {
  white-space: pre-wrap;
}
.comment-area.strike {
  text-decoration: line-through;
}
</style>
